import { createRouter, createWebHistory } from 'vue-router'
import layout from '../layout/index.vue'
import Index from '../view/index'
import about from '../view/about'
import contactus from '../view/contactus'
import coreproduct from '../view/coreproduct'
import ourserverA from '../view/ourserverA'
import ourserverB from '../view/ourserverB'
import ourserverC from '../view/ourserverC'
import ourserverD from '../view/ourserverD'
import share from '../view/share'
import weatable from '../view/weatable'




export default createRouter({
  history: createWebHistory(),
  routes: [
   {path: '/',
    component: layout,
    children: [
    {
      path: '',
      name: 'Index',
      component: Index,
    },

    {
      path: '/about',
      name: 'about',
      component: about,
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: contactus,
    },
    {
      path: '/share',
      name: 'share',
      component: share,
    },
    {
      path: '/coreproduct/:id',
      name: 'Coreproduct',
      component: coreproduct
    },
    {
      path: '/weatable/:id',
      name: 'weatable',
      component: weatable
    },
    {
      path: '/ourserver-0',
      name: 'ourserver-0',
      component: ourserverA
    },
    {
      path: '/ourserver-1',
      name: 'ourserver-1',
      component: ourserverB
    },
    {
      path: '/ourserver-2',
      name: 'ourserver-2',
      component: ourserverC
    },
    {
      path: '/ourserver-3',
      name: 'ourserver-3',
      component: ourserverD
    }
    ]  
    }
  ],
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0, behavior: 'smooth'}
  }
  // scrollBehavior(to) {
  //   if (to.hash) {
  //     return {
  //       selector: to.hash,
  //       behavior: 'smooth'
  //     };
  //   }else {
  //     return { x: 0, y: 0 }; // 滚动到页面顶部
  //   }
  // }
})
